import React from 'react';
import { Avatar } from '@ublend-npm/aulaui-next';
import Tooltip from '@ublend-npm/react-tooltip';

import StarIcon from '@material-ui/icons/Star';
import BarChartIcon from '@material-ui/icons/BarChart';
import * as TYPES from '$variables/types';
import { STUDENT } from '$variables/constants';

import {
  Wrapper,
  Container,
  LeftDecorations,
  Content,
  Title,
  SubTitle,
  Tabs,
  Tab,
  TabText,
} from './StudentDetails.styled';

import { User } from '$variables/types';

const StudentDetails = ({ student: { email, fullName, avatar }, viewAs }) => (
  <Wrapper data-testid="student-details" fullPadding={viewAs === STUDENT}>
    <Container>
      <LeftDecorations>
        <Avatar size="large" name={fullName} src={avatar} />
      </LeftDecorations>
      <Content>
        <Title>{fullName}</Title>
        <SubTitle>{email}</SubTitle>
      </Content>
    </Container>
    {viewAs !== STUDENT && (
      <Tabs>
        <Tab isActive>
          <StarIcon />
          <TabText>Grades</TabText>
        </Tab>
        <Tab isDisabled>
          <BarChartIcon />
          <TabText>
            <Tooltip title="🚧 Coming soon!" position="top" spacing={4}>
              Engagement Insights
            </Tooltip>
          </TabText>
        </Tab>
      </Tabs>
    )}
  </Wrapper>
);

StudentDetails.propTypes = {
  student: User.isRequired,
  viewAs: TYPES.ViewAs.isRequired,
};

export default StudentDetails;
